import { TabContext } from '@mui/lab';

import { Paper } from '@ocx/ui';
import type { OffersCarouselCategory } from '@ocx/data-offers';
import type { AltriaOffersNearbyStatus } from '@ocx/feat-local-offers';

import { OffersCarouselHeader } from './offers-carousel-header.component';
import { OffersCarouselPanelController } from './offers-carousel-panel.controller';

export type OffersCarouselControllerProps = {
  onCategoryChange: (categoryId: string) => void;
  categories: OffersCarouselCategory[];
  selectedCategory: OffersCarouselCategory | null;
  hasAltriaOffersNearby?: AltriaOffersNearbyStatus;
  isCategoryLoading?: boolean;
};

export const OffersCarouselController = ({
  categories,
  selectedCategory,
  onCategoryChange,
  hasAltriaOffersNearby,
  isCategoryLoading,
}: OffersCarouselControllerProps) => {
  if (!categories.length || !selectedCategory) {
    return null;
  }

  return (
    <TabContext value={selectedCategory.id}>
      <Paper data-testid="offers-carousel-container" p={0} sx={{ overflow: 'hidden' }}>
        <OffersCarouselHeader categories={categories} onCategoryChange={onCategoryChange} />
        {categories.map((category) => {
          const isSelected = category.id === selectedCategory.id;
          const panelCategory = isSelected ? selectedCategory : category;
          return (
            <OffersCarouselPanelController
              id={category.id}
              key={category.id}
              offers={panelCategory.offers}
              banners={panelCategory.banners}
              isCategoryLoading={isSelected ? isCategoryLoading : false}
              hasAltriaOffersNearby={hasAltriaOffersNearby}
            />
          );
        })}
      </Paper>
    </TabContext>
  );
};
